import api from "./axiosConfig";

export const getCapabilities = async () => {
  const res = await api.get("About/capabilities/");
  return res.data[0]; // backend returns an array with one main object
};
